// EWODiscripencyAction.js
import {
  FETCH_EWO_DISCRIPENCY_REQUEST,
  FETCH_EWO_DISCRIPENCY_SUCCESS,
  FETCH_EWO_DISCRIPENCY_FAILURE,
  FETCH_IWO_WITHOUT_EWO_REQUEST,
  FETCH_IWO_WITHOUT_EWO_SUCCESS,
  FETCH_IWO_WITHOUT_EWO_FAILURE,
  FETCH_EWO_WITHOUT_INVOICE_REQUEST,
  FETCH_EWO_WITHOUT_INVOICE_SUCCESS,
  FETCH_EWO_WITHOUT_INVOICE_FAILURE,
} from "../constants/EWODiscripencyConstants";

import EWODiscripencyService from "../service/EWODiscripencyService";

export const fetchEWODiscripency = (date) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EWO_DISCRIPENCY_REQUEST });
    const data = await EWODiscripencyService.getAll(date);
    dispatch({ type: FETCH_EWO_DISCRIPENCY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_EWO_DISCRIPENCY_FAILURE,
      payload: error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};

export const fetchIWOWithoutEWO = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_IWO_WITHOUT_EWO_REQUEST });
    const data = await EWODiscripencyService.getIWOWithoutEWO();
    dispatch({ type: FETCH_IWO_WITHOUT_EWO_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_IWO_WITHOUT_EWO_FAILURE,
      payload: error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};

export const fetchEWOWithoutInvoice = () => async (dispatch) => {
  try {
    dispatch({ type: FETCH_EWO_WITHOUT_INVOICE_REQUEST });
    const data = await EWODiscripencyService.getEWOWithoutInvoice();
    dispatch({ type: FETCH_EWO_WITHOUT_INVOICE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: FETCH_EWO_WITHOUT_INVOICE_FAILURE,
      payload: error.response?.data?.message || error.message || "Failed to fetch",
    });
  }
};